import React from 'react';
import { Tag, Tooltip } from 'antd';
import { LockOutlined, ToolOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { GATE, gateMessage, toTenScale } from '../utils/moduleGate.js';

// Nhãn trạng thái module trong giáo trình: đang xây dựng / chưa mở / đã đạt test
export function ModuleGateTag({ gate, style }) {
  if (!gate) return null;
  const base = { fontSize: 11, margin: 0, flexShrink: 0, ...style };

  if (gate.status === GATE.UNDER_CONSTRUCTION) {
    return (
      <Tag icon={<ToolOutlined />} color="default" style={base}>
        Đang xây dựng
      </Tag>
    );
  }
  if (gate.status === GATE.LOCKED) {
    return (
      <Tooltip title={gateMessage(gate)}>
        <Tag icon={<LockOutlined />} color="gold" style={base}>
          Chưa mở
        </Tag>
      </Tooltip>
    );
  }
  if (gate.status === GATE.PASSED) {
    return (
      <Tag icon={<CheckCircleOutlined />} color="green" style={base}>
        Đạt test {toTenScale(gate.bestScore)}/10
      </Tag>
    );
  }
  if (gate.hasQuiz && gate.bestScore !== null && gate.bestScore !== undefined) {
    return (
      <Tag color="orange" style={base}>
        Test {toTenScale(gate.bestScore)}/10 - chưa đạt
      </Tag>
    );
  }
  return null;
}
